// scroll-animations.js - Scroll-reveal Intersection Observer

export function initScrollAnimations() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const delay = parseInt(el.dataset.delay || '0');
      const isFade = el.classList.contains('animate-in-fade-hidden');
      observer.unobserve(el);
      setTimeout(() => {
        el.classList.remove('animate-in-hidden', 'animate-in-fade-hidden');
        el.classList.add(isFade ? 'animate-in-fade-ready' : 'animate-in-ready');
      }, delay);
    });
  }, { threshold: 0.12 });
  
  document.querySelectorAll('.animate-in-hidden, .animate-in-fade-hidden')
    .forEach(el => observer.observe(el));
}
